export enum TypicalWeekPeriodCode {
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS',
    LAST_365_DAYS = 'LAST_365_DAYS',
    CUSTOM = 'CUSTOM'
}

export interface TypicalWeekPeriod {
    periodCode: TypicalWeekPeriodCode;
    startDate: string | null;
    endDate: string | null;
    color: string;
    previousPeriodActivated: boolean;
    previousPeriodColor: string;
    previousYearPeriodActivated: boolean;
    previousYearPeriodColor: string;
    customName: string | null;
}
export interface TypicalWeekPeriodApiFormat {
    periodCode: TypicalWeekPeriodCode;
    startDate: string | null;
    endDate: string | null;
    hexaColor: string;
    lastPeriodActivated: boolean;
    lastPeriodHexaColor: string;
    lastYearPeriodActivated: boolean;
    lastYearPeriodHexaColor: string;
    displayParameters: {
        customName: string | null;
    };
}

export interface TypicalWeekPeriodRequest {
    periodCode: TypicalWeekPeriodCode | string;
    periodStart: string;
    periodEnd: string;
}
export interface TypicalWeekTimeseriesPoint {
    dayOfWeek: number;
    hour: number;
    value: number;
}

export interface TypicalWeekTimeseries {
    periodCode: string;
    values: TypicalWeekTimeseriesPoint[];
}
